import React from 'react';

type Props = {
  fill?: string;
  size?: string;
};
function IconPin(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '12'}
      height={props.size ?? '12'}
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        fill={props.fill ?? '#8F80FF'}
        d="M6.619 1.546A4 4 0 002 5.5c0 2.454 1.966 4.17 3.141 4.977.255.176.556.27.865.27.297 0 .588-.089.834-.257 1.148-.784 3.076-2.45 3.157-4.833a3.965 3.965 0 00-3.378-4.11zM6 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
      ></path>
    </svg>
  );
}

export const SvgIconPin = React.memo(IconPin);
